export default "__VITE_ASSET__f6ed7b9c__"